import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { getNotes } from "store/services/Notes/notesThunks";
import { NotesResponse } from "types/notes";

interface NotesState {
  data: NotesResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: NotesState = {
  data: null,
  loading: false,
  error: null,
};

const notesSlice = createSlice({
  name: "notes",
  initialState,
  reducers: {
    handleResetNotes: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNotes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNotes.fulfilled, (state, action: PayloadAction<NotesResponse>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getNotes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch notes";
      });
  },
});

export const { handleResetNotes } = notesSlice.actions;

export default notesSlice;
